export enum OrganizationType {
  VERIFIED = 'VERIFIED',
  DRAFT = 'DRAFT',
  ON_VERIFICATION = 'ON_VERIFICATION',
  NOT_VERIFIED = 'NOT_VERIFIED',
}
